import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import { action, set } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { isEmpty, isNone, isPresent } from '@ember/utils';
import Component from '@glimmer/component';
import { styleEntry } from '@mylighthouse/prism-ember';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import { and } from 'ember-truth-helpers';
import generateOtaLink from 'frontend-utils/utils/url/generate-ota-link';
import HotelRankingTooltipsTooltipRankingCalendar from 'lumen/components/hotel/ranking/tooltips/tooltip-ranking-calendar';

interface HotelRankingCalendarsDaysDayRankingSignature {
  Args: {
    arrivalRankingInfo: unknown;
    dayComponentHeight: unknown;
    model: unknown;
    monthMoment: unknown;
  };
}

export default class HotelRankingCalendarsDaysDayRanking extends Component<HotelRankingCalendarsDaysDayRankingSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare intl: Services['intl'];

  isHovered = false;
  nrOfHotels = '';

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get averageRanking() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.arrivalRankingInfo?.averageRanking;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get dayNumber() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (this.period?.day?.date) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
      return this.period?.day?.date.date();
    }
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasPeriod() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.period?.id;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasRankingValue() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.ownRanking && this.ownRanking.ranking > 0;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isPartOfInactiveMonth() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (this.period?.day?.date) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      return !this.period?.day?.date.isSame(this.args.monthMoment, 'month');
    }
    return false;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isToday() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (this.period?.day?.date) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
      return this.period?.day?.date.isSame(
        this.hotelAndMarketService.getLocalTime(),
        'day',
      );
    }
    return false;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get ownRanking() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const rankingArray = this.period?.rankings;
    const hid = this.hotelAndMarketService.hotel?.hotelinfo?.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (rankingArray && !isEmpty(rankingArray[hid])) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
      return rankingArray[hid][0];
    }
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get ownRankingValue() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const ranking = this.ownRanking;
    if (isNone(ranking)) {
      return this.intl.t('ranking.no_ranking');
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (ranking.ranking <= 0) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
      return this.intl.t(ranking.message);
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return ranking.ranking;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get period() {
    return this.args.model;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get rankingPositionBackground() {
    let backgroundClass = 'sold-out';

    // background color
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { ownRanking } = this;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { averageRanking } = this;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (ownRanking && ownRanking.ranking > 0 && averageRanking > 0) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (ownRanking.ranking <= averageRanking * 0.95) {
        backgroundClass = 'green';
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      } else if (ownRanking.ranking <= averageRanking * 1.05) {
        backgroundClass = 'orange';
      } else {
        backgroundClass = 'red';
      }
    }
    return backgroundClass;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get rankingRedirectUrl() {
    // ota, ownHotel, maxPersons, source, city
    const redirectUrl = generateOtaLink(
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
      this.args.selectedOTA?.id,
      // @ts-expect-error: Incorrect type
      this.hotelAndMarketService.hotel?.hotelinfo?.id,
      this.hotelAndMarketService.hotel?.id,
      this.hotelAndMarketService.hotel?.isTripadvisorRebranding,
      this.period,
      2,
      'app_arrivalranking',
      true,
    );
    return redirectUrl;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get tooltipData() {
    // @ts-expect-error: Incorrect type
    const res = [];
    const compset = this.hotelAndMarketService.activeCompset?.competitors;
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const rankings = this.args.model.rankings ?? {};
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    Object.keys(rankings).forEach((hotel) => {
      let hotelinfo;
      if (hotel === this.hotelAndMarketService.hotel?.hotelinfo?.id) {
        hotelinfo = this.hotelAndMarketService.hotel?.hotelinfo;
      } else if (compset) {
        hotelinfo = compset.find((comp) => comp.id === hotel);
      }
      res.push({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        ranking: rankings[hotel][0].ranking,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        message: rankings[hotel][0].message,
        hotel: hotelinfo,
      });
    });
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return res.sort((a, b) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (a.ranking <= 0) {
        return 1;
      }

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (b.ranking <= 0) {
        return -1;
      }

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return a.ranking - b.ranking;
    });
  }

  constructor() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line prefer-rest-params
    super(...arguments);

    set(
      this,
      'nrOfHotels',
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      isPresent(this.ownRanking) && this.ownRanking.available_hotels !== 0
        ? this.intl.t('ranking.of_hotels', {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            count: this.ownRanking.available_hotels,
          })
        : '',
    );
  }

  @action
  onMouseEnter(): void {
    set(this, 'isHovered', true);
  }

  @action
  onMouseLeave(): void {
    set(this, 'isHovered', false);
  }

  <template>
    {{! template-lint-disable no-nested-interactive }}
    <div class="ins-calendar-day-container">
      <div
        class="ins-calendar-day"
        style={{styleEntry "height" (concat @dayComponentHeight "px")}}
      >
        {{#if this.hasPeriod}}
          <a
            href={{this.rankingRedirectUrl}}
            rel="noopener noreferrer"
            target="_blank"
          >
            <div
              class="calendar-day-content
                {{if this.isPartOfInactiveMonth 'inactive'}}"
            >
              <div class="clearfix">
                <div class="ins-day-number {{if this.isToday 'today'}}">
                  {{this.dayNumber}}
                </div>
              </div>
              <div class="day-info-block-wrapper">
                <div
                  class="day-info-aligned-block
                    {{this.rankingPositionBackground}}"
                  role="tooltip"
                  {{on "mouseenter" this.onMouseEnter}}
                  {{on "mouseleave" this.onMouseLeave}}
                >
                  <div class="own-rate-container">
                    <h4>
                      {{this.ownRankingValue}}
                    </h4>
                  </div>
                  <div class="comp-percentage-container">
                    {{#if this.hasRankingValue}}
                      <p class="text-200--medium">
                        {{this.nrOfHotels}}
                      </p>
                    {{/if}}
                  </div>
                </div>
              </div>
            </div>
          </a>
          {{#if (and this.tooltipData.length this.isHovered)}}
            <EmberTooltip
              @isShown={{this.isHovered}}
              @side="top"
              @tooltipClass="base-tooltip arrival-day-tooltip"
            >
              {{! @glint-expect-error: Incorrect type }}
              <HotelRankingTooltipsTooltipRankingCalendar
                @tooltipData={{this.tooltipData}}
              />
            </EmberTooltip>
          {{/if}}
        {{/if}}
      </div>
    </div>
  </template>
}
